$(document).ready(function () {
  let item_price = $("span.price.price--sale > span").html();
  let saving_amount = 0;
  if (item_price) {
    item_price = item_price.replace("$", "");
    saving_amount = percentage(25, item_price);
  
    $("#saving-amount").html(saving_amount);
  }
  $(".subprop2").click(function () {
    if($('.dtc-delivery-frequency.alternative-selector').hasClass('hidden')) {
      $(".skio-plan-picker").addClass("margin-b-70");
    } else {
      $(".skio-plan-picker").addClass("margin-b-80");
    }
    $(".step-one-discount-message").hide();
    $(".dtc-subscription-push-2").hide();
    $(".dtc-experiment-price-on-atc-button").show();
    $(".dtc-save-amount-footer").show();
    $(".dtc-experiment-button-atc").css("width","100%");
  });

  $(".subprop1").click(function () {
    if($('.dtc-delivery-frequency.alternative-selector').hasClass('hidden')) {
      $(".skio-plan-picker").removeClass("margin-b-70");
    } else {
      $(".skio-plan-picker").removeClass("margin-b-80");
    }
    $(".step-one-discount-message").show();
    $(".dtc-subscription-push-2").show();
    $(".dtc-experiment-price-on-atc-button").hide();
    $(".dtc-save-amount-footer").hide();
    $(".dtc-experiment-button-atc").css("width","100%");
  });

  const urlParams2 = new URLSearchParams(window.location.search);
  
  if (urlParams2.get('shopping') === '2') {
    $(".subprop1").trigger("click");
    $("#one-time").attr('checked', true);
    $(".skio-planner__picker-aternative").addClass("dtc-force-style");
  }else{
    $(".dtc-skio-planner-tricker-click").trigger("click");
  }

  $(".dtc-sub-bottle").click(function(){
    $(".dtc-sub-bottle").removeClass("active");
    let bottles_amount = $(this).data("dtc-quanty");
    const dataSellingPlan = $(this).data("selling-plan");
    const subscriptionSelectorAlternative = $(this).closest('.main-delivery').find('.dtc-delivery-frequency.alternative-selector select');
    $(this).addClass("active");
    setTimeout(function() {
      if (!!dataSellingPlan) {
        subscriptionSelectorAlternative.val(dataSellingPlan);
        subscriptionSelectorAlternative.trigger('change');
      }
      $('.product_section .product-quantity-box .quantity').val(bottles_amount);
    }, 200);
  });

  $('.sng-sku-button').on('click', function(){
    var bottle3_pro = 0;
    var bottle6_pro = 0;
    var each_price = 0;
  	var bottle3_price = 0;
  	var bottle6_price = 0;

    each_price = parseFloat($('.sng-sku').attr('data-price'));
    bottle3_pro = 50000/each_price;
  	bottle6_pro = 100000/each_price;
    bottle3_price = (each_price - 500);
    bottle6_price = (each_price - 1000);
    $('.sng-sku-button').removeClass('active');
    $(this).addClass('active');
    if($(this).attr('id') == 'bottle_1'){
      $('.product_section .product-quantity-box .quantity').val(1);
      var price = Shopify.formatMoney(each_price, $('body').data('money-format'));
      let shopPaySinglePrice = Shopify.formatMoney(each_price / 4, $('body').data('money-format'));
      setTimeout(function(){
        $('.price-ui .price .money').text(price);
        $("#dtc-single-selling-price").html(price);
        $("#dtc-was-price").html(" ");
        $("#dtc-single-selling-price").addClass("saving-active");
        $('#one-time-purchase-saving-percange').html(" ");
        $('#one-time-purchase-saving-percange').removeClass("saving-percantage-active");
        $('.price-dtc-single-price').removeClass("actve-dtc-saving-active");
        $('#dtc-was-price').removeClass("saving-percantage-active");
        $("#pay-shop-price").html(price);
        $("#shop-pay-single-payment").html(shopPaySinglePrice);
      },10);
     
    }else if($(this).attr('id') == 'bottle_3'){
      $('.product_section .product-quantity-box .quantity').val(3);
      var price = Shopify.formatMoney(each_price * 3, $('body').data('money-format'));
      var price_real = Shopify.formatMoney(bottle3_price * 3, $('body').data('money-format'));
      let shopPaySinglePrice = Shopify.formatMoney(bottle3_price * 3 / 4, $('body').data('money-format'));
      setTimeout(function(){
        $('.price-ui .price .money').html(price_real + '<span class="was_price">'+ price + '</span><br>' + 'You Save&nbsp;' + bottle3_pro.toFixed(0) + '%');
        $("#dtc-single-selling-price").html(price_real);
        $('#dtc-was-price').addClass("saving-percantage-active");
        $("#dtc-was-price").html(price);
        $('.price-dtc-single-price').addClass("actve-dtc-saving-active");
        $('#one-time-purchase-saving-percange').html(`You’re saving ${bottle3_pro.toFixed(2)}%`);
        $("#dtc-single-selling-price").addClass("saving-active");
        $('#one-time-purchase-saving-percange').addClass("saving-percantage-active");
        $("#pay-shop-price").html(price_real);
        $("#shop-pay-single-payment").html(shopPaySinglePrice)
      },10);
    }else{
      $('.product_section .product-quantity-box .quantity').val(6);
      var price = Shopify.formatMoney(each_price * 6, $('body').data('money-format'));
      var price_real = Shopify.formatMoney(bottle6_price * 6, $('body').data('money-format'));
      let shopPaySinglePrice = Shopify.formatMoney(bottle6_price * 6 / 4, $('body').data('money-format'));
      setTimeout(function(){
        $("#dtc-single-selling-price").html(price_real);
        $("#dtc-was-price").html(price);
        $('#dtc-was-price').addClass("saving-percantage-active");
        $("#dtc-single-selling-price").addClass("saving-active");
        $('.price-dtc-single-price').addClass("actve-dtc-saving-active");
        $('.price-ui .price .money').html(price_real + '<span class="was_price">'+ price + '</span><br>' + 'You Save&nbsp;' + bottle6_pro.toFixed(2) + '%');
        $('#one-time-purchase-saving-percange').html(`You’re saving ${bottle6_pro.toFixed(2)}%`);
        $('#one-time-purchase-saving-percange').addClass("saving-percantage-active");
        $("#pay-shop-price").html(price_real);
        $("#shop-pay-single-payment").html(shopPaySinglePrice)
      },10);
    }
  });

  $('.sub-switcher-div-alternative.one-time').on('click', function(){
    $('.sub-switcher-div-alternative.one-time ')
    $('.product_section .product-quantity-box .quantity').val(1);
    let each_price = parseFloat($('.sng-sku').attr('data-price'));
    let shopPaySinglePrice = Shopify.formatMoney(each_price / 4, $('body').data('money-format'));
    $("#shop-pay-single-payment").html(shopPaySinglePrice);
    $("#pay-shop-price").html($("#dtc-single-selling-price").html());

    let $optionAltElement = $('.dtc-one-time-purchase-option-picker .sng-sku-button.active');
    if ($optionAltElement.length) updateGalleryImageWithAlt($optionAltElement);
  });

  $('.sub-switcher-div-alternative.subscription').on('click', function(){
    let productPrice = $(".subsccription-dtc-label-wraper__discounted-price").html();
    let prudctPriceTrim = productPrice.replace("$", '');
    let shopPayPrice = (+prudctPriceTrim / 4).toString();
    shopPayPrice = shopPayPrice.substring(0, shopPayPrice.length -2)
    $("#pay-shop-price").html($(".subsccription-dtc-label-wraper__discounted-price").html());
    $("#shop-pay-single-payment").html("$"+ shopPayPrice)

    let $optionAltElement = $('.main-delivery .dtc-sub-bottle.active');
    if ($optionAltElement.length) updateGalleryImageWithAlt($optionAltElement);
  });

  let bottleQuantity = 0;

  const changePricesOnClick = (bottleQuantity, productPrice, selectedElement) => {
    if (typeof productPrice !== 'string' || !selectedElement) return; // guard: PDP-only DOM
    let shopPayPaymentTextPrice =  $("#shop-pay-single-payment");
    let productPriceTrim = productPrice.replace("$", '')
    let productPriceNumber = +productPriceTrim
    let totalPrice = productPriceNumber * bottleQuantity;
    let finalPrice = "$" + totalPrice;
    let shopPayFinalPrice = (totalPrice / 4).toString().slice(0, -2)
    $("#pay-shop-price").html(finalPrice);
    shopPayPaymentTextPrice.html("$" + shopPayFinalPrice)

    if(document.querySelector('.sub-switcher__alternative-radio:checked').closest('.subscription')) {
      const save = selectedElement.getAttribute('data-save')
      if(save) $('.subscriptions-dtc-prices-saving-amount-text').html("You’re saving " + save)

      const pricePerBottle = selectedElement?.querySelector('[data-price-per-bottle]')?.getAttribute('data-price-per-bottle')
      if(pricePerBottle) $('.subsccription-dtc-label-wraper__discounted-price').html(pricePerBottle)

      if(selectedElement) {
        const pricePerBottle = selectedElement.querySelector('[data-price-per-bottle]')?.getAttribute('data-price-per-bottle')
        if(pricePerBottle) $('.subsccription-dtc-label-wraper__discounted-price').html(pricePerBottle)

        const totalPrice = selectedElement.querySelector('[data-price-total]')?.getAttribute('data-price-total')

        $('.purchase-details .add_to_cart .text').html("Add to Cart - " + totalPrice)
      }
    } else {
      setTimeout(function(){
        $('.purchase-details .add_to_cart .text').html("Add to Cart - " + $('#dtc-single-selling-price').html())
      }, 100)
    }
  }

  setTimeout(function(){
    changePricesOnClick(1, $(".subsccription-dtc-label-wraper__discounted-price").html(), document.querySelector('.dtc-sub-bottle.active'))
  }, 100)

  $(".sub-switcher__alternative-radio").change(function() {
    let productPrice = $(".subsccription-dtc-label-wraper__discounted-price").html();
    changePricesOnClick(document.querySelector('.dtc-sub-bottle.active').dataset.dtcQuanty, productPrice, document.querySelector('.dtc-sub-bottle.active'))
  });

  $(".dtc-sub-bottle").click(function(e){
    let productPrice = $(".subsccription-dtc-label-wraper__discounted-price").html();
    let quantity = $(this).data('dtc-quanty') ?? '1';
    bottleQuantity = parseInt(quantity);

    if (quantity == '1') $("#pay-shop-price").html(productPrice);
    changePricesOnClick(bottleQuantity, productPrice, e.target?.closest('.dtc-sub-bottle'));
  });

  $(".sng-sku-button").click(function(e){
    let productPrice = $(".subsccription-dtc-label-wraper__discounted-price").html();
    changePricesOnClick(1, productPrice, e.target?.closest('.dtc-sub-bottle'))
  });
});

function percentage(percent, total) {
  let num = parseFloat((total * percent) / 100);
  num = floorFigure(num);
  return num;
}

function floorFigure(figure, decimals) {
  if (!decimals) decimals = 2;
  var d = Math.pow(10, decimals);
  return (parseInt(figure * d) / d).toFixed(decimals);
}

$(document).on('click', function(e) {
  const $target = $(e.target);
  const $optionAltElement = $target.closest('[data-option-alt]');
  if ($optionAltElement.length) updateGalleryImageWithAlt($optionAltElement);
});


function checkForShoppingParam() {
  const urlParams = new URLSearchParams(window.location.search);
  const divElement = document.querySelector('.sub-switcher-div.subprop2.rc_block.rc_block__type.rc_block__type__autodeliver');
  const divElement2 = document.querySelector('.sub-switcher-div.subprop1.rc_block.rc_block__type.rc_block__type__onetime.rc_block__type--active');

  if (urlParams.get('shopping') === '2') {
    $('.one-time-selector__label').trigger('click');
    divElement?.classList?.remove('rc_block__type--active');
    divElement2?.classList?.add('rc_block__type--active');
  }else{
    divElement?.classList?.add('rc_block__type--active');
    divElement2?.classList?.remove('rc_block__type--active');
  }
};
setTimeout(function(){
  checkForShoppingParam();
}, 0)

function updateGalleryImageWithAlt($optionAltElement) {
  const experiment = window.igData?.user?.getTestGroup('072f79c3-4391-4ac8-a168-3dc443f95554') // NAME: Product | All Infographics
  const isControl = experiment?.isControl

  if (experiment && !isControl) return;

  if (!$optionAltElement.length) return;
  let optionAlt = $optionAltElement.attr('data-option-alt');

  let bottleNumber = optionAlt.includes('bottle_') ? optionAlt.split('_')[1] : null;    
  if(!bottleNumber) return;

  const experimentUGC = window.igData?.user?.getTestGroup('2c5a1b34-3435-4483-9d0d-51cb24c53915') // NAME: Product | UGC Videos Information
  const isControlUGC = experimentUGC?.isControl

  if (experimentUGC && !isControlUGC) {
    const $bottleImage = bottleNumber == 1 
      ? $(`.product-images__experiment--ugc-videos .product-gallery__thumbnail img[alt="bottle${bottleNumber}"].product-gallery__thumbnail--ugc-exp`)
      : $(`.product-images__experiment--ugc-videos .product-gallery__thumbnail img[alt="bottle${bottleNumber}"]`);
  
    if($bottleImage.length) $bottleImage.click()
    
    return
  }

  const $bottleImage = $(`.product-gallery__thumbnail img[alt="bottle${bottleNumber}"]`);
  
  if($bottleImage.length) $bottleImage.click()
}